import React from "react";

class InputField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: (props.locked && props.active) || false,
      value: props.value || "",
      id: props.id || "",
      name: props.name || "",
      type: props.type || "type",
      error: props.error || "",
      label: props.label || "",
      required: props.required || "",
      hint: props.hint || "",
      placeholder: props.placeholder || ""
    };
  }

  changeValue = event => {
    const value = event.target.value;
    this.setState({ value, error: "" });
    if (typeof this.props.onChange === "function") {
      this.props.onChange(event);
    }
  };

  static getDerivedStateFromProps = (nextProps, prevState) => {
    return ({
      error: nextProps.error,
      required: nextProps.required,
      value: nextProps.value,
      type: nextProps.type
    });
  }

  // USE THIS CODE WHEN YOU NEED PREDICTION(AUTO COMPLERTE) WORDS.
  /*
      handleKeyPress(event) {
        if (event.which === 13) {
          this.setState({ value: this.props.predicted });
        }
      }
    */

  render() {
    const { active, value, error, label, id, type, name,placeholder } = this.state;
    const { predicted, locked } = this.props;
    const fieldClassName = `form-field ${(locked ? active : active || value) &&
      "active"} ${locked && !active && "locked"}`;
    //console.log(this.props.predicted)

    return (
      <div className={fieldClassName}>
        {active && value && predicted && predicted.includes(value) && (
          <p className="predicted">{predicted}</p>
        )}
        <label htmlFor={id} className={error && "error"}>
          {error || label}
        </label>
        <input
          id={id}
          className="form-control"
          type={type}
          value={value}
          name={name}
          placeholder={placeholder}
          onChange={this.changeValue}
          //onKeyPress={this.handleKeyPress.bind(this)}
          onFocus={() => !locked && this.setState({ active: true })}
          onBlur={() => !locked && this.setState({ active: false })}
        />
        <div className="form-hint">{this.state.hint}</div>

        <span className="error">{this.state.label}</span>
      </div>
    );
  }
}

export default InputField;
